/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, April 13th 2022, 6:29:27 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { MarketPlaceComponent } from "./MarketPlaceComponent";
import { useToggleState } from "ui-widgets/dialogs/useToggleState";

export const OpenMarketPlaceButtonWrapper = ({ children }) => {
  const {
    open: preBuiltOpenState,
    handleClose: handleClosePreBuilt,
    handleOpen: handleOpenPreBuilt,
  } = useToggleState();

  return (
    <>
      {React.Children.map(children, (child) => React.cloneElement(child, { onClick: handleOpenPreBuilt }))}
      <MarketPlaceComponent open={preBuiltOpenState} onClose={handleClosePreBuilt} />
    </>
  );
};
